import { useAccordion } from '../../../customHook.js/useAccordion'
import useScrollAnimation from '../../../customHook.js/useScrollAnimation'

import RenderContent from '../../../helpers/RenderContent'
import { highlightText } from '../../../helpers/helperFunctions'
import { pension1 } from '../../../const/contentData'
import modelRTL from '../../../const/modelRTL'
import pension from '../../../images/pension.jpg'
import iHealth from '../../../images/pension.svg'
import kfarHashashuim from '../../../images/kfarHashashuim.JPG'
import classes from '../content.module.css'
import pclasses from './Pension.module.css'

function Pension({ searchTerm }) {
  const moduleName = 'pension'

  const { selectedRow, highlightedText, changeSelectedRow } = useAccordion(
    moduleName,
    searchTerm,
    0
  )

  const getToContainer = useScrollAnimation(moduleName)

  return (
    <div
      className={`${classes.main_container} ${
        !modelRTL[moduleName] && 'row_reverse'
      }`}
      id={moduleName}
    >
      <div
        className={`${classes.text_area} ${
          modelRTL[moduleName] ? classes.hidden_left : classes.hidden_right
        } ${getToContainer && classes.visible}`}
        dir="rtl"
      >
        <div className={classes.drop_down_section}>
          <div className="c_blue">
            <img className={classes.section_img} src={iHealth} alt="iHealth" />
          </div>
          <div>
            {pension1.map(({ id, title, content, uniqueId }) => (
              <div key={id} id={uniqueId}>
                <div
                  className={`${classes.drop_down_title}  ${
                    selectedRow === id && classes.drop_down_open
                  } c_pink`}
                  onClick={() => changeSelectedRow(id)}
                >
                  <div className={classes.toggle_icon_container}>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow !== id && classes.visible
                      }`}
                    >
                      +
                    </span>
                    <span
                      className={`${classes.toggle_icon} ${
                        selectedRow === id && classes.visible
                      }`}
                    >
                      -
                    </span>
                  </div>
                  {highlightText(title, highlightedText)}
                </div>
                <div
                  className={`${classes.text_container} ${
                    selectedRow === id && classes.show
                  }`}
                >
                  <RenderContent
                    content={content}
                    searchTerm={highlightedText}
                  />
                  {id === 1 && (
                    <div className={pclasses.container}>
                      <table className={pclasses.table}>
                        <thead>
                          <tr>
                            <th>מנהל ההסדר</th>
                            <th>איש קשר</th>
                            <th>תפקיד</th>
                            <th>נייד</th>
                            <th>מייל</th>
                            <th>וואצ-אפ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td rowSpan="3">תמורה</td>
                            <td>קרן גלעד</td>
                            <td>מנהל תיק/סוכנות</td>
                            <td>052-3514473</td>
                            <td>kereng@tmu.co.il</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td>שגית טרבלסי</td>
                            <td>מנהל תיק/סוכנות</td>
                            <td>052-2030134</td>
                            <td>sagitt@tmu.co.il</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td>שירות לקוחות</td>
                            <td>מוקד שירות לקוחות</td>
                            <td>*6099</td>
                            <td>sherut@tmu.co.il</td>
                            <td>054-6367944</td>
                          </tr>
                          <tr>
                            <td rowSpan="2">מבטח סיימון</td>
                            <td>אורית אלשייך</td>
                            <td>מנהל תיק/סוכנות</td>
                            <td>052-2732153</td>
                            <td>orit@mvs.co.il</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td>שירות לקוחות</td>
                            <td>מוקד שירות לקוחות</td>
                            <td>03-7966060 שלוחה 1</td>
                            <td>mvs@mvs.co.il</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                  {id === 2 && (
                    <div className={pclasses.container}>
                      <table className={pclasses.table}>
                        <thead>
                          <tr>
                            <th>מוקד שירות טלפוני</th>
                            <th>מייל</th>
                            <th>וואצ-אפ</th>
                            <th>אתר NICE במדנס</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>073-2128257</td>
                            <td>nice@madanes.com</td>
                            <td>052-8259424</td>
                            <td>nice.madanes.com</td>
                          </tr>
                          <tr>
                            <td>
                              שלוחה 1- מוקד שירות לאחר הצטרפות שלוחה 2- מוקד
                              הצטרפות
                            </td>
                            <td>מענה יינתן תוך יום עסקיםאחד בלבד</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                  {id === 4 && (
                    <div className={pclasses.container}>
                      <table className={pclasses.table}>
                        <thead>
                          <tr>
                            <th>שנות ותק</th>
                            <th>מספר ימי ההבראה במגזר הציבורי ובמגזר הפרטי</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>שנה ראשונה</td>
                            <td>5 ימים</td>
                          </tr>
                          <tr>
                            <td>שנה שנייה ושנה שלישית</td>
                            <td>6 ימים</td>
                          </tr>
                          <tr>
                            <td>שנה רביעית עד שנה עשירית</td>
                            <td>7 ימים</td>
                          </tr>
                          <tr>
                            <td>שנה אחת עשרה עד שנה חמש עשרה</td>
                            <td>8 ימים</td>
                          </tr>
                          <tr>
                            <td>שנה שש עשרה עד שנה תשע עשרה</td>
                            <td>9 ימים</td>
                          </tr>
                          <tr>
                            <td>שנה עשרים ואילך</td>
                            <td>10 ימים</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                  {id === 15 && (
                    <img
                      className={pclasses.kfarHashashuim}
                      src={kfarHashashuim}
                      alt="food"
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className={`${classes.main_img_container} ${
          modelRTL[moduleName] ? classes.hidden_right : classes.hidden_left
        }  ${getToContainer && classes.visible}`}
        dir="rtl"
      >
        <img src={pension} alt="pension" />
        <div>
          <h2>פנסיה, ביטוח</h2>
          <h2>והטבות ששווה להכיר</h2>
        </div>
      </div>
    </div>
  )
}

export default Pension
